function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackYourConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    height: 112,
    width: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#A3A3A3",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45,
    y1: 434,
    x2: 458,
    y2: 434
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#A3A3A3",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 322,
    y1: 448.333,
    x2: 446,
    y2: 448.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#A3A3A3",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 168.333,
    y1: 448.333,
    x2: 192.333,
    y2: 448.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#A3A3A3",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 68.333,
    y1: 448.333,
    x2: 160.333,
    y2: 448.333
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504461"
    },
    d: "M393.59,108v315.66c0,4.61-3.73,8.34-8.33,8.34H130.5c-4.61,0-8.34-3.73-8.34-8.34V108 c0-4.6,3.73-8.33,8.34-8.33h254.76C389.86,99.67,393.59,103.4,393.59,108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.953,
    y: 109.558,
    style: {
      fill: "#FFFFFF"
    },
    width: 247.85,
    height: 312.552
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M357,276.25h-26.5v-26.5H357V276.25z M332.5,274.25H355v-22.5h-22.5V274.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 251.242,
    style: {
      fill: "#A3A3A3"
    },
    width: 141.333,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 261.908,
    style: {
      fill: "#A3A3A3"
    },
    width: 140.333,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 271.758,
    style: {
      fill: "#A3A3A3"
    },
    width: 37.666,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 271.758,
    style: {
      fill: "#A3A3A3"
    },
    width: 87.167,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M357,228.25h-26.5v-26.5H357V228.25z M332.5,226.25H355v-22.5h-22.5V226.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 203.242,
    style: {
      fill: "#A3A3A3"
    },
    width: 141.333,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 213.909,
    style: {
      fill: "#A3A3A3"
    },
    width: 140.333,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 223.758,
    style: {
      fill: "#A3A3A3"
    },
    width: 37.666,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 223.758,
    style: {
      fill: "#A3A3A3"
    },
    width: 87.167,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M357,179.583h-26.5v-26.5H357V179.583z M332.5,177.583H355v-22.5h-22.5V177.583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 154.575,
    style: {
      fill: "#A3A3A3"
    },
    width: 141.333,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 165.242,
    style: {
      fill: "#A3A3A3"
    },
    width: 140.333,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 175.091,
    style: {
      fill: "#A3A3A3"
    },
    width: 37.666,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 175.091,
    style: {
      fill: "#A3A3A3"
    },
    width: 87.167,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M357,370.25h-26.5v-26.5H357V370.25z M332.5,368.25H355v-22.5h-22.5V368.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 345.242,
    style: {
      fill: "#A3A3A3"
    },
    width: 141.333,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 355.908,
    style: {
      fill: "#A3A3A3"
    },
    width: 140.333,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 365.758,
    style: {
      fill: "#A3A3A3"
    },
    width: 37.666,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 365.758,
    style: {
      fill: "#A3A3A3"
    },
    width: 87.167,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M357,321.583h-26.5v-26.5H357V321.583z M332.5,319.583H355v-22.5h-22.5V319.583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 296.575,
    style: {
      fill: "#A3A3A3"
    },
    width: 141.333,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 307.242,
    style: {
      fill: "#A3A3A3"
    },
    width: 140.333,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 317.092,
    style: {
      fill: "#A3A3A3"
    },
    width: 37.666,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 317.092,
    style: {
      fill: "#A3A3A3"
    },
    width: 87.167,
    height: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.75,
    y: 99.67,
    style: {
      fill: "#A3A3A3"
    },
    width: 142.26,
    height: 29.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.746,
    y: 93.142,
    style: {
      fill: "#A3A3A3"
    },
    width: 142.264,
    height: 32.979
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M281.88,69.2L234,69l-19.66,30.93h87.08L281.88,69.2z M257.88,90.99c-3.69,0-6.68-3-6.68-6.69 c0-3.69,2.99-6.68,6.68-6.68s6.68,2.99,6.68,6.68C264.56,87.99,261.57,90.99,257.88,90.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M188.333,95h138c0,0,0.667,27.667,0,27.667c-0.667,0-139.333-28-139.333-28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.333,
    y: 71.334,
    style: {
      fill: "#BFBFBF"
    },
    width: 42.667,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M291.392,92.513c-3.876-6.489-10.355-17.107-11.242-17.973c0.005,0.004,0.104,0.099,0.284,0.159 l0.633-1.897c0.412,0.137,1.102,0.367,12.042,18.686L291.392,92.513z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M344,175.5c-0.025,0-0.051-0.001-0.076-0.001c-0.689-0.021-1.34-0.326-1.796-0.843l-7.667-8.667 c-0.915-1.034-0.818-2.614,0.216-3.529c1.033-0.915,2.612-0.819,3.528,0.216l5.906,6.676l17.954-17.954 c0.977-0.977,2.559-0.977,3.535,0c0.977,0.976,0.977,2.559,0,3.535l-19.833,19.833C345.298,175.237,344.662,175.5,344,175.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      opacity: 0.34,
      fill: "#DD5954"
    },
    d: "M242.671,218.025c-0.354-0.031-0.714-0.065-1.061-0.001 c-0.586,0.108-1.048,0.379-1.512,0.668c-0.262,0.262-0.509,0.538-0.732,0.829c-0.082,0.108-0.182,0.167-0.285,0.205 c-0.028,0.087-0.063,0.172-0.086,0.259c-0.281-0.158-0.57-0.305-0.861-0.447c-0.504-0.144-0.993-0.325-1.491-0.494 c-0.006,0.003-0.013,0.002-0.019,0.005c-0.014-0.009-0.031-0.018-0.046-0.027c-0.081-0.027-0.161-0.056-0.243-0.082 c-0.367-0.117-0.833-0.342-1.237-0.282c-0.2,0.03-1.065,0.246-0.757,0.636c0.176,0.223,0.002,0.628-0.295,0.673 c-0.524,0.346-0.609,0.713-0.255,1.102c0.177,0.263,0.043,0.574-0.208,0.736c-0.079,0.306-0.158,0.612-0.238,0.918 c0.201,0.265,0.027,0.588-0.213,0.754c-1.277,0.883,1.03,1.781,1.624,2.096c0.765,0.406,1.497,0.738,2.323,0.821 c0.305-0.12,0.543-0.324,0.668-0.648c0.083-0.007,0.169-0.004,0.25-0.023c0.498-0.12,0.798-0.49,0.844-0.88 c0.571,0.163,1.158,0.126,1.567-0.436c0.259-0.354,0.272-0.695,0.15-1.007c0.611,0.032,1.094-0.171,1.138-0.893 c0.015-0.258-0.097-0.494-0.262-0.707c0.068-0.067,0.126-0.148,0.189-0.223c-0.2-1.06,0.197-2.152,0.744-3.076 C242.455,218.352,242.559,218.191,242.671,218.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#A3A3A3"
    },
    d: "M271,179.066l-7.181,2.841l-0.901,0.356l-0.102,0.046l-0.52,0.201l0.056,0.064 c-0.464,0.256-0.901,0.585-1.3,0.959l-52.965,49.484c-0.945,0.198-1.886,0.371-2.82,0.556c-3.228,0.54-6.443,0.85-9.374,0.593 c-2.946-0.228-5.58-0.98-7.732-2.208c-1.822-1.05-3.329-2.502-4.585-4.311l0.921-0.379c0,0-5.458-20.666-6.89-21.693 c-1.548-2.283-6.193-2.436-6.193-2.436l-0.157,0.208l-0.398-3.801l-0.547-5.223h0.719c4.183,0,7.606-3.632,7.606-8.07v-11.206 c0-0.868-0.092-1.713-0.259-2.529c0.405-0.587,0.699-1.39,0.699-2.49c0-2.297,0-3.738,0-4.481 c3.875-2.112,1.945-7.545-1.548-7.545c0,0.685-0.155,1.979-5.419,1.979c-1.781,0-8.128-0.076-15.25,0 c-7.122,0.076-8.128,4.948-8.128,4.948s-2.245,2.539-2.4,10.232c-0.155,7.693,7.567,16.656,11.689,16.656 c0-0.049,0.001-0.142,0.002-0.268c0.421,0.271,0.853,0.525,1.295,0.759l-1.135,10.839c-2.086,0.172-3.815,0.744-5.18,1.41 l-0.046-0.024c-1.015,0.514-2.198,1.179-3.344,2.037c-1.028,0.511-1.938,1.323-2.591,2.416c-0.062,0.104-0.117,0.2-0.176,0.301 c-0.141,0.186-0.287,0.368-0.418,0.565c-1.993,2.458-8.96,19.927-8.96,19.927l1.056,0.216c-0.137,0.534-0.283,1.063-0.41,1.604 c-0.927,4.068-1.623,8.303-1.705,12.853c-0.048,2.275,0.066,4.633,0.458,7.086c0.385,2.451,1.047,5.01,2.254,7.552 c0.929,1.995,2.241,3.942,3.845,5.597l-3.137,28.574l0.29-0.006c-0.576,2.483-1.152,4.967-1.717,7.45 c-0.409,1.799-0.817,3.59-1.226,5.389l-4.022,17.738l-3.911,17.775c-2.601,11.847-5.239,23.684-7.682,35.568 c-1.245,5.937-2.397,11.902-3.558,17.857c-0.594,2.978-1.161,5.965-1.7,8.951c-0.539,2.987-1.096,5.974-1.598,8.979 c-0.035,0.208-0.039,0.415-0.046,0.622l-0.658-0.036L113,432.078l15.624-0.771l-6.245-1.643l4.225-15.431l-1.589-0.086 c0.864-2.441,1.7-4.886,2.529-7.332c0.994-2.877,1.951-5.764,2.889-8.659c1.886-5.773,3.79-11.545,5.592-17.345 c3.66-11.582,7.125-23.21,10.627-34.828l5.239-17.437l5.128-17.464c0.975-3.307,1.941-6.613,2.898-9.929 c0.601-2.072,1.2-4.136,1.794-6.206c1.336-0.258,2.616-0.878,3.678-1.869l0.371-0.352l2.273-0.047 c1.137,4.501,2.278,8.999,3.421,13.478l2.285,9.28l2.174,9.262c0.725,3.069,1.356,6.129,2.044,9.207 c0.594,3.051,1.208,6.111,1.737,9.171c2.09,12.203,2.963,24.342,2.731,36.801c-0.231,11.481-1.203,23.149-2.204,34.909 l-0.447-0.032l-0.21,18.364l14.378-0.571l-5.822-1.707l3.301-15.251l-0.028-0.002c1.219-5.005,2.382-10.032,3.367-15.122 c0.66-3.206,1.18-6.467,1.774-9.7c0.316-1.617,0.502-3.27,0.734-4.905l0.678-4.932c0.715-6.613,1.263-13.327,1.245-20.068 c0-1.69,0.019-3.38-0.009-5.06l-0.214-5.042l-0.111-2.53l-0.195-2.503l-0.409-5.014c-0.325-3.325-0.734-6.622-1.124-9.92 c-0.474-3.261-0.91-6.549-1.412-9.792c-0.539-3.224-1.078-6.467-1.654-9.673l-1.765-9.6c-0.195-1.023-0.381-2.037-0.585-3.051 c-0.407-2.16-0.833-4.308-1.252-6.46l1.079-0.022c0,0-1.285-8.748-3.077-20.679l45.701-42.702c0.143,0.238,0.381,0.417,0.682,0.45 l2.81,0.311c0.177,0.02,0.347-0.011,0.498-0.08c0.282-0.13,0.492-0.398,0.529-0.725c0.012-0.1-0.005-0.195-0.026-0.288 c0.171,0.016,0.338-0.006,0.485-0.073c0.263-0.121,0.464-0.361,0.52-0.663c0.062-0.333-0.079-0.646-0.324-0.85l0.09,0.013 c0.188,0.028,0.372-0.002,0.532-0.076c0.272-0.125,0.477-0.378,0.525-0.691c0.063-0.416-0.178-0.795-0.551-0.957l0.231,0.023 c0.174,0.017,0.341-0.013,0.488-0.081c0.286-0.132,0.496-0.403,0.53-0.734c0.052-0.502-0.319-0.95-0.83-1.001l-0.347-0.035 l31.279-29.226c0.892-0.84,1.533-1.845,1.904-2.923l3.465-6.22l5.843-10.467L271,179.066z M185.789,243.603l1.644,0.533 c0.551,0.13,1.107,0.226,1.66,0.335l1.659,0.306c0.549,0.069,1.093,0.095,1.639,0.141c0.951,0.069,1.903,0.149,2.828,0.122 l-9.431,8.811c-0.552-3.604-1.114-7.252-1.674-10.848l0.042,0.02C184.688,243.258,185.244,243.411,185.789,243.603z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M173.532,206.564l0.039,0.985c0.029,0.383,0.042,0.758,0.084,1.148 c0.064,0.771,0.134,1.552,0.24,2.326c0.206,1.55,0.468,3.086,0.846,4.568c0.358,1.495,0.824,2.912,1.35,4.285 c0.314,0.647,0.551,1.355,0.914,1.954l0.481,0.944l0.549,0.875c1.475,2.333,3.342,4.125,5.659,5.384 c2.317,1.246,5.152,2.01,8.324,2.24c3.154,0.261,6.615-0.054,10.091-0.601c1.74-0.325,3.504-0.602,5.271-1.063l2.659-0.629 c0.882-0.259,1.758-0.533,2.65-0.779c7.116-2.043,14.176-4.791,21.401-7.491l0.028-0.01c0.9-0.336,1.924,0.067,2.287,0.901 c0.29,0.667,0.068,1.408-0.492,1.85c-6.032,4.749-12.601,8.949-19.816,12.415c-0.901,0.437-1.818,0.846-2.73,1.27l-2.84,1.125 c-0.96,0.359-1.884,0.779-2.881,1.086l-2.995,0.911c-0.987,0.327-2.032,0.556-3.081,0.784c-1.053,0.219-2.078,0.498-3.163,0.661 c-1.089,0.159-2.186,0.296-3.285,0.427c-1.098,0.133-2.26,0.111-3.393,0.164c-1.129,0.075-2.308-0.031-3.482-0.11 c-0.588-0.046-1.173-0.073-1.764-0.143l-1.785-0.311c-0.595-0.111-1.193-0.209-1.787-0.34l-1.77-0.541 c-0.586-0.195-1.185-0.35-1.759-0.589l-1.711-0.757c-2.286-1.016-4.36-2.437-6.262-3.987c-0.875-0.828-1.778-1.66-2.555-2.552 c-0.748-0.905-1.545-1.802-2.154-2.763c-2.648-3.79-4.19-7.889-5.135-11.919c-0.459-2.026-0.809-4.046-0.957-6.074 c-0.084-1.014-0.146-2.027-0.155-3.051c-0.012-0.508,0.008-1.031,0.013-1.546c0.02-0.552,0.034-0.994,0.087-1.709 c0.245-3.314,3.342-5.817,6.919-5.59c3.337,0.212,5.912,2.725,6.043,5.753L173.532,206.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M172.333,202.265c1.542,1.043,7.417,22.009,7.417,22.009l-6.875,2.664L169.5,204.35 L172.333,202.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18151C"
    },
    d: "M170.583,170.294c0,0,3.333-0.463,3.333-4.093s0-5.174,0-5.174H156.5c0,0-2.417,2.626-2.583,10.58 c-0.167,7.954,8.146,17.221,12.583,17.221c0-0.753,0.167-11.043,0.167-11.043L170.583,170.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M159.24,213.45c-4.24,0.398-8.02-2.456-8.46-6.376c-0.05-0.482-0.05-1.001,0-1.464l2.17-19.535 c0.31-2.817,3.03-4.865,6.06-4.578c2.66,0.26,4.68,2.206,4.94,4.578l0.53,4.763l0.59,5.31l1.05,9.461 C166.55,209.539,163.47,213.042,159.24,213.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M170.91,216.84c-0.326-1.573-0.692-3.144-1.109-4.731c-0.205-0.794-0.426-1.589-0.667-2.403 l-0.377-1.237l-0.212-0.65l-0.12-0.352l-0.162-0.445c-0.54-1.3-1.304-2.455-2.222-3.463c-1.66-0.235-3.324-0.446-4.997-0.588 c-4.875-0.416-9.922-0.628-14.74,0.303c-3.181,3.286-4.317,8.062-2.488,12.465c0,0-0.009-0.035,0.003-0.011l0.036,0.07 l0.077,0.154l0.171,0.365l0.354,0.803c0.236,0.549,0.473,1.122,0.699,1.705c0.458,1.161,0.891,2.359,1.296,3.57 c0.812,2.423,1.524,4.902,2.121,7.401c1.18,5.001,1.97,10.094,2.17,15.158c0.106,2.532,0.109,5.065-0.08,7.568 c-0.171,2.507-0.466,5.002-0.961,7.448c-0.91,4.921-2.571,9.656-4.804,14.176l-0.124,0.249c-1.896,3.826-0.429,8.445,3.553,10.674 c4.28,2.396,9.846,1.122,12.431-2.844c3.628-5.567,6.541-11.586,8.489-17.82c1.018-3.111,1.785-6.273,2.387-9.45 c0.62-3.179,1.005-6.375,1.251-9.571c0.503-6.398,0.282-12.776-0.439-19.096C172.076,223.128,171.565,219.984,170.91,216.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M195.57,359.81c0.02,6.839-0.57,13.65-1.34,20.359l-0.73,5.004c-0.25,1.659-0.45,3.336-0.79,4.976 c-0.64,3.281-1.2,6.589-1.91,9.841c-1.34,6.524-2.98,12.946-4.67,19.349c-0.76,2.845-3.85,4.578-6.92,3.883 c-1.99-0.454-3.47-1.816-4.07-3.494c-0.24-0.658-0.34-1.371-0.27-2.094v-0.037c1.17-12.974,2.38-25.845,2.65-38.495 c0.25-12.64-0.69-24.955-2.94-37.336c-0.57-3.104-1.23-6.209-1.87-9.304c-0.74-3.123-1.42-6.227-2.2-9.341l-2.34-9.397 l-2.46-9.415c-1.45-5.356-2.9-10.731-4.34-16.115c-0.75-2.762-1.49-5.514-2.22-8.285v-0.009c-1.2-4.513-2.39-9.035-3.57-13.557 c-0.45-1.714-0.46-3.438-0.09-5.06c0.95-4.254,4.46-7.84,9.32-8.915c6.71-1.501,13.46,2.326,15.08,8.553 c0.03,0.111,0.07,0.278,0.09,0.398c1.79,8.09,3.55,16.18,5.26,24.316c0.78,3.688,1.54,7.376,2.28,11.083 c0.22,1.029,0.42,2.057,0.63,3.095l1.9,9.739c0.62,3.253,1.2,6.542,1.78,9.814c0.54,3.29,1.01,6.626,1.52,9.934 c0.42,3.345,0.86,6.691,1.21,10.064l0.44,5.087l0.21,2.539l0.12,2.567l0.23,5.115C195.59,356.381,195.57,358.096,195.57,359.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M161.08,273.434c-0.03,0.111-0.08,0.269-0.11,0.38c-0.6,2.029-1.2,4.059-1.82,6.088v0.009 c-1.23,4.142-2.48,8.275-3.74,12.408c-0.7,2.307-1.41,4.606-2.12,6.913c-1.03,3.364-2.07,6.719-3.12,10.073l-5.52,17.718 l-5.64,17.69c-3.77,11.787-7.5,23.584-11.44,35.334c-1.94,5.884-3.99,11.741-6.02,17.598c-1.01,2.938-2.04,5.866-3.11,8.785 c-1.05,2.919-2.1,5.838-3.21,8.748c-1,2.65-4.14,4.05-7.01,3.114c-2.55-0.834-4.02-3.234-3.6-5.625 c0.54-3.049,1.14-6.079,1.72-9.109c0.58-3.03,1.19-6.06,1.83-9.081c1.25-6.042,2.49-12.093,3.83-18.117 c2.63-12.056,5.47-24.066,8.27-36.085l4.21-18.033l4.33-17.996c0.44-1.826,0.88-3.642,1.32-5.467 c0.84-3.475,1.69-6.95,2.55-10.425c1.65-6.691,3.33-13.372,5.04-20.044c1.53-5.977,7.99-9.675,14.44-8.266 c1.2,0.259,2.32,0.686,3.33,1.242C159.91,263.694,162.33,268.569,161.08,273.434z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A3A3A3"
    },
    cx: 160.018,
    cy: 267.3,
    rx: 21.649,
    ry: 20.935
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M168.17,313.726l2.34,9.397c0.632,2.521,1.202,5.038,1.787,7.562 c1.463-9.177,2.447-18.437,3.556-27.72c0.015-0.122,0.076-0.214,0.155-0.284c-0.001-0.005-0.008-0.028-0.008-0.028 s6.85-3.549,11.52-5.931c-0.74-3.707-1.5-7.395-2.28-11.083l-23.87,2.558c1.44,5.384,2.89,10.759,4.34,16.115L168.17,313.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M155.41,292.32l0.59-5.495l-23.32,1.529c-0.86,3.475-1.71,6.95-2.55,10.425 l23.16,0.454L155.41,292.32z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M151.5,199.794c0.599-0.044,11.333,3.552,11.333,3.552l2.833-3.552c0,0,5,0.154,6.667,2.471 c1.667,2.317,15,87.88,15,87.88l-55.667,1.081l10.167-87.263C141.833,203.964,145.167,200.257,151.5,199.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M144.667,230.065l4.333,0.579l1.833-14.17v74.289l-17.5,0.463l5.833-53.439 C139.167,237.788,145.667,229.602,144.667,230.065z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156,286.824l0.12-0.102l-6.67-7.451c-0.02-0.028-0.03-0.056-0.05-0.074l-1.24,1.094 c-2.46,2.159-3.11,5.412-1.91,8.155c0.08,0.056,0.16,0.13,0.25,0.232C149,291.69,156,286.824,156,286.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M159.76,283.535l110.74-96.792l0.29-0.315l-7.23-7.497c-0.5,0.26-0.97,0.593-1.4,0.973 l-109.17,96.125c0.11,0.093,0.22,0.176,0.31,0.278L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M156.12,286.723l3.64-3.188l-6.46-7.228c-0.09-0.102-0.2-0.185-0.31-0.278l-3.59,3.169 c0.02,0.018,0.03,0.046,0.05,0.074L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M263.5,178.866l0.06,0.065c0.16-0.102,0.33-0.195,0.5-0.269L263.5,178.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M272.87,175.372l-7.73,2.882l-0.97,0.361l-0.11,0.046c-0.17,0.074-0.34,0.167-0.5,0.269 l7.23,7.497l4.06-4.402l1.98-2.141C274.74,178.217,273.55,176.614,272.87,175.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885l8.42-9.128l-12.38,4.615C273.55,176.614,274.74,178.217,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD6F2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463l3.51-3.086 c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463 l3.51-3.086c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026c0.95,1.779,1.07,3.827,0.38,5.662l3.73-6.311c-0.8-0.501-1.51-1.001-2.13-1.492 L274.85,182.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026l-4.06,4.402l3.21,3.327l1.23-2.067C275.92,185.853,275.8,183.805,274.85,182.026z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA64D"
    },
    d: "M276.83,179.885l-1.98,2.141l-4.06,4.402l3.21,3.327l1.23-2.067l3.73-6.311 C278.16,180.877,277.45,180.376,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M184.656,253.887c2.063,0.736,2.168,2.286,1.584,3.328c-0.723,0.122-0.77-1.47-1.358-1.879 c-0.889-0.824-2.555,0.673-4.429,0.673c-0.49,0.001-0.351-2.761-0.351-2.761c1.489-1.27,2.978-2.541,4.467-3.811 c0.148-0.127,0.318-0.261,0.52-0.261c0.148,0,0.283,0.075,0.409,0.148c1.191,0.697,2.295,1.521,3.286,2.449"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M185.68,251.632c1.598,1.082,2.505,2.981,2.294,4.805c-0.048,0.417-0.538,0.938-0.822,0.611 c0,0-0.872-3.414-2.545-2.774s-0.335-1.667-0.335-1.667L185.68,251.632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M188.13,251.621c1.397,1.166,1.476,3.432,0.162,4.679c0,0-0.466,0.552-0.717-0.223 c-0.251-0.775-2.361-3.372-2.361-3.372l0.042-1.144l1.442-0.426L188.13,251.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M187.276,252.187c2.35-0.161,3.647,2.319,4.09,1.911c0.443-0.408-0.87-2.465-1.979-3.238 c-1.11-0.773-2.366-1.632-3.754-1.632c-0.357,0-0.671,0.705-0.671,0.88C184.962,250.281,187.276,252.187,187.276,252.187z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M151.292,211.453l-1.567,5.182l-1.553,5.275c-1.007,3.505-1.937,6.994-2.674,10.425 c-0.757,3.42-1.298,6.807-1.5,9.943c-0.085,1.565-0.084,3.062,0.034,4.413c0.137,1.344,0.356,2.556,0.699,3.495 c0.358,0.939,0.737,1.65,1.264,2.285c0.545,0.604,1.288,1.203,2.366,1.686c1.066,0.488,2.412,0.885,3.914,1.121 c1.518,0.24,3.16,0.337,4.876,0.372c3.44,0.023,7.116-0.327,10.855-0.792c3.75-0.465,7.563-1.107,11.501-1.639l0.017-0.002 c0.872-0.118,1.674,0.493,1.792,1.365c0.08,0.589-0.175,1.147-0.616,1.483c-3.221,2.444-6.665,4.554-10.314,6.408 c-3.659,1.836-7.527,3.409-11.778,4.443c-2.13,0.522-4.365,0.863-6.724,1.023c-2.37,0.101-4.898-0.017-7.543-0.657 c-2.622-0.645-5.419-1.818-7.823-3.742c-2.41-1.904-4.341-4.407-5.613-6.982c-1.299-2.579-2.011-5.176-2.426-7.662 c-0.422-2.489-0.545-4.881-0.493-7.189c0.087-4.616,0.837-8.913,1.835-13.04c1.032-4.119,2.368-8.057,3.947-11.86 c0.796-1.899,1.633-3.772,2.575-5.598c0.468-0.914,0.936-1.827,1.437-2.73c0.526-0.915,0.999-1.757,1.63-2.753 c1.962-3.096,6.063-4.016,9.159-2.054c2.574,1.631,3.644,4.74,2.804,7.522L151.292,211.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M165.256,190.85h-4.014c-10.666,0-19.392-8.726-19.392-19.392v-0.165 c0-6.711,5.491-12.202,12.202-12.202h7.19c6.711,0,12.202,5.491,12.202,12.202v11.369 C173.443,187.165,169.759,190.85,165.256,190.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M145.799,201.209c-2.209,1.055-5.154,2.729-7.028,5.396c4.15-1.055,10.174,0.496,13.186,5.458 c0.335,1.303,1.473-7.195,1.473-7.195L145.799,201.209z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "174.44,433.119 174.667,414.487 187.205,415.335 183.651,430.807 189.919,432.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "102.783,432.063 103.861,413.263 117.428,413.958 112.88,429.613 119.602,431.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M138.77,206.605c-2.145,2.494-9.645,20.217-9.645,20.217L149,230.644l5.75-22.935l-10.625-2.548 L138.77,206.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      opacity: 0.34,
      fill: "#DD5954"
    },
    d: "M242.671,218.025c-0.354-0.031-0.714-0.065-1.061-0.001 c-0.586,0.108-1.048,0.379-1.512,0.668c-0.262,0.262-0.509,0.538-0.732,0.829c-0.082,0.108-0.182,0.167-0.285,0.205 c-0.028,0.087-0.063,0.172-0.086,0.259c-0.281-0.158-0.57-0.305-0.861-0.447c-0.504-0.144-0.993-0.325-1.491-0.494 c-0.006,0.003-0.013,0.002-0.019,0.005c-0.014-0.009-0.031-0.018-0.046-0.027c-0.081-0.027-0.161-0.056-0.243-0.082 c-0.367-0.117-0.833-0.342-1.237-0.282c-0.2,0.03-1.065,0.246-0.757,0.636c0.176,0.223,0.002,0.628-0.295,0.673 c-0.524,0.346-0.609,0.713-0.255,1.102c0.177,0.263,0.043,0.574-0.208,0.736c-0.079,0.306-0.158,0.612-0.238,0.918 c0.201,0.265,0.027,0.588-0.213,0.754c-1.277,0.883,1.03,1.781,1.624,2.096c0.765,0.406,1.497,0.738,2.323,0.821 c0.305-0.12,0.543-0.324,0.668-0.648c0.083-0.007,0.169-0.004,0.25-0.023c0.498-0.12,0.798-0.49,0.844-0.88 c0.571,0.163,1.158,0.126,1.567-0.436c0.259-0.354,0.272-0.695,0.15-1.007c0.611,0.032,1.094-0.171,1.138-0.893 c0.015-0.258-0.097-0.494-0.262-0.707c0.068-0.067,0.126-0.148,0.189-0.223c-0.2-1.06,0.197-2.152,0.744-3.076 C242.455,218.352,242.559,218.191,242.671,218.025z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M240.204,222.1c-0.159,0.069-0.339,0.1-0.525,0.083l-6.163-0.582 c-0.549-0.052-0.949-0.507-0.893-1.016c0.055-0.509,0.546-0.88,1.096-0.828l6.163,0.582c0.549,0.052,0.949,0.507,0.893,1.016 C240.738,221.691,240.512,221.967,240.204,222.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M239.459,223.832c-0.172,0.075-0.37,0.105-0.573,0.077l-5.237-0.729 c-0.546-0.076-0.922-0.548-0.84-1.054c0.082-0.507,0.59-0.856,1.137-0.779l5.237,0.729c0.546,0.076,0.922,0.548,0.84,1.054 C239.972,223.449,239.751,223.705,239.459,223.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M238.577,225.431c-0.182,0.079-0.391,0.108-0.604,0.073l-4.342-0.735 c-0.543-0.092-0.903-0.575-0.805-1.078c0.099-0.504,0.618-0.838,1.163-0.745l4.342,0.734c0.543,0.092,0.903,0.575,0.805,1.078 C239.076,225.065,238.86,225.308,238.577,225.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M237.513,226.534c-0.162,0.07-0.346,0.101-0.536,0.082l-3.025-0.316 c-0.549-0.057-0.944-0.516-0.882-1.025c0.062-0.509,0.557-0.874,1.105-0.817l3.025,0.316c0.549,0.057,0.944,0.516,0.882,1.024 C238.042,226.13,237.817,226.402,237.513,226.534z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M155.333,170.12c0,0,3.333-0.455,3.333-4.016c0-3.561,0-5.077,0-5.077H141.25 c0,0-2.417,2.576-2.583,10.381c-0.167,7.805,8.146,16.898,12.583,16.898c0-0.739,0.167-10.836,0.167-10.836L155.333,170.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M151.458,180.835L151.458,180.835c-1.26,0-2.292-1.031-2.292-2.292v-3.216 c0-1.26,1.031-2.292,2.292-2.292l0,0c1.26,0,2.292,1.031,2.292,2.292v3.216C153.75,179.804,152.719,180.835,151.458,180.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF4040",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M167.083,172.785 c-0.396,1.564,2.25,8.398,2.25,8.398H166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M163.417,175.179c0,0.906-0.793,1.641-1.771,1.641s-1.771-0.735-1.771-1.641 c0-0.906,0.793-1.641,1.771-1.641S163.417,174.272,163.417,175.179z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#221E28"
    },
    cx: 171.313,
    cy: 175.179,
    rx: 1.771,
    ry: 1.641
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.063,170.584 c0,0-2.188-1.084-5.813,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M168.563,170.468 c0,0,3.25-0.753,4.688,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.375,183.152h7.125c0,0-0.125,4.286-3.688,4.286S163.375,183.152,163.375,183.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M153.792,178.48L153.792,178.48c-0.848,0-1.542-0.694-1.542-1.542v-6.261 c0-0.848,0.694-1.542,1.542-1.542l0,0c0.848,0,1.542,0.694,1.542,1.542v6.261C155.333,177.786,154.64,178.48,153.792,178.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M141.25,161.027c0,0,1.083-4.942,8.75-5.02c7.667-0.077,14.5,0,16.417,0 c5.667,0,5.833-1.313,5.833-2.008c4.667,0,6.75,8.495-2.5,8.495s-14.667,0-14.667,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M165.07,196.149c-10.638-1.788-10.777-10.008-9.826-7.775c0.963,2.224,7.761,2.446,9.141,2.465 L165.07,196.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.417,175.321c0.814,0,0.816-1.173,0-1.173C161.602,174.148,161.601,175.321,162.417,175.321 L162.417,175.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.917,175.321c0.814,0,0.816-1.173,0-1.173C171.102,174.148,171.101,175.321,171.917,175.321 L171.917,175.321z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M173.532,206.564l0.039,0.985c0.029,0.383,0.042,0.758,0.084,1.148 c0.064,0.771,0.134,1.552,0.24,2.326c0.206,1.55,0.468,3.086,0.846,4.568c0.358,1.495,0.824,2.912,1.35,4.285 c0.314,0.647,0.551,1.355,0.914,1.954l0.481,0.944l0.549,0.875c1.475,2.333,3.342,4.125,5.659,5.384 c2.317,1.246,5.152,2.01,8.324,2.24c3.154,0.261,6.615-0.054,10.091-0.601c1.74-0.325,3.504-0.602,5.271-1.063l2.659-0.629 c0.882-0.259,1.758-0.533,2.65-0.779c7.116-2.043,14.176-4.791,21.401-7.491l0.028-0.01c0.9-0.336,1.924,0.067,2.287,0.901 c0.29,0.667,0.068,1.408-0.492,1.85c-6.032,4.749-12.601,8.949-19.816,12.415c-0.901,0.437-1.818,0.846-2.73,1.27l-2.84,1.125 c-0.96,0.359-1.884,0.779-2.881,1.086l-2.995,0.911c-0.987,0.327-2.032,0.556-3.081,0.784c-1.053,0.219-2.078,0.498-3.163,0.661 c-1.089,0.159-2.186,0.296-3.285,0.427c-1.098,0.133-2.26,0.111-3.393,0.164c-1.129,0.075-2.308-0.031-3.482-0.11 c-0.588-0.046-1.173-0.073-1.764-0.143l-1.785-0.311c-0.595-0.111-1.193-0.209-1.787-0.34l-1.77-0.541 c-0.586-0.195-1.185-0.35-1.759-0.589l-1.711-0.757c-2.286-1.016-4.36-2.437-6.262-3.987c-0.875-0.828-1.778-1.66-2.555-2.552 c-0.748-0.905-1.545-1.802-2.154-2.763c-2.648-3.79-4.19-7.889-5.135-11.919c-0.459-2.026-0.809-4.046-0.957-6.074 c-0.084-1.014-0.146-2.027-0.155-3.051c-0.012-0.508,0.008-1.031,0.013-1.546c0.02-0.552,0.034-0.994,0.087-1.709 c0.245-3.314,3.342-5.817,6.919-5.59c3.337,0.212,5.912,2.725,6.043,5.753L173.532,206.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M172.333,202.265c1.542,1.043,7.417,22.009,7.417,22.009l-6.875,2.664L169.5,204.35 L172.333,202.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18151C"
    },
    d: "M170.583,170.294c0,0,3.333-0.463,3.333-4.093s0-5.174,0-5.174H156.5c0,0-2.417,2.626-2.583,10.58 c-0.167,7.954,8.146,17.221,12.583,17.221c0-0.753,0.167-11.043,0.167-11.043L170.583,170.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M159.24,213.45c-4.24,0.398-8.02-2.456-8.46-6.376c-0.05-0.482-0.05-1.001,0-1.464l2.17-19.535 c0.31-2.817,3.03-4.865,6.06-4.578c2.66,0.26,4.68,2.206,4.94,4.578l0.53,4.763l0.59,5.31l1.05,9.461 C166.55,209.539,163.47,213.042,159.24,213.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M170.91,216.84c-0.326-1.573-0.692-3.144-1.109-4.731c-0.205-0.794-0.426-1.589-0.667-2.403 l-0.377-1.237l-0.212-0.65l-0.12-0.352l-0.162-0.445c-0.54-1.3-1.304-2.455-2.222-3.463c-1.66-0.235-3.324-0.446-4.997-0.588 c-4.875-0.416-9.922-0.628-14.74,0.303c-3.181,3.286-4.317,8.062-2.488,12.465c0,0-0.009-0.035,0.003-0.011l0.036,0.07 l0.077,0.154l0.171,0.365l0.354,0.803c0.236,0.549,0.473,1.122,0.699,1.705c0.458,1.161,0.891,2.359,1.296,3.57 c0.812,2.423,1.524,4.902,2.121,7.401c1.18,5.001,1.97,10.094,2.17,15.158c0.106,2.532,0.109,5.065-0.08,7.568 c-0.171,2.507-0.466,5.002-0.961,7.448c-0.91,4.921-2.571,9.656-4.804,14.176l-0.124,0.249c-1.896,3.826-0.429,8.445,3.553,10.674 c4.28,2.396,9.846,1.122,12.431-2.844c3.628-5.567,6.541-11.586,8.489-17.82c1.018-3.111,1.785-6.273,2.387-9.45 c0.62-3.179,1.005-6.375,1.251-9.571c0.503-6.398,0.282-12.776-0.439-19.096C172.076,223.128,171.565,219.984,170.91,216.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M195.57,359.81c0.02,6.839-0.57,13.65-1.34,20.359l-0.73,5.004c-0.25,1.659-0.45,3.336-0.79,4.976 c-0.64,3.281-1.2,6.589-1.91,9.841c-1.34,6.524-2.98,12.946-4.67,19.349c-0.76,2.845-3.85,4.578-6.92,3.883 c-1.99-0.454-3.47-1.816-4.07-3.494c-0.24-0.658-0.34-1.371-0.27-2.094v-0.037c1.17-12.974,2.38-25.845,2.65-38.495 c0.25-12.64-0.69-24.955-2.94-37.336c-0.57-3.104-1.23-6.209-1.87-9.304c-0.74-3.123-1.42-6.227-2.2-9.341l-2.34-9.397 l-2.46-9.415c-1.45-5.356-2.9-10.731-4.34-16.115c-0.75-2.762-1.49-5.514-2.22-8.285v-0.009c-1.2-4.513-2.39-9.035-3.57-13.557 c-0.45-1.714-0.46-3.438-0.09-5.06c0.95-4.254,4.46-7.84,9.32-8.915c6.71-1.501,13.46,2.326,15.08,8.553 c0.03,0.111,0.07,0.278,0.09,0.398c1.79,8.09,3.55,16.18,5.26,24.316c0.78,3.688,1.54,7.376,2.28,11.083 c0.22,1.029,0.42,2.057,0.63,3.095l1.9,9.739c0.62,3.253,1.2,6.542,1.78,9.814c0.54,3.29,1.01,6.626,1.52,9.934 c0.42,3.345,0.86,6.691,1.21,10.064l0.44,5.087l0.21,2.539l0.12,2.567l0.23,5.115C195.59,356.381,195.57,358.096,195.57,359.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M161.08,273.434c-0.03,0.111-0.08,0.269-0.11,0.38c-0.6,2.029-1.2,4.059-1.82,6.088v0.009 c-1.23,4.142-2.48,8.275-3.74,12.408c-0.7,2.307-1.41,4.606-2.12,6.913c-1.03,3.364-2.07,6.719-3.12,10.073l-5.52,17.718 l-5.64,17.69c-3.77,11.787-7.5,23.584-11.44,35.334c-1.94,5.884-3.99,11.741-6.02,17.598c-1.01,2.938-2.04,5.866-3.11,8.785 c-1.05,2.919-2.1,5.838-3.21,8.748c-1,2.65-4.14,4.05-7.01,3.114c-2.55-0.834-4.02-3.234-3.6-5.625 c0.54-3.049,1.14-6.079,1.72-9.109c0.58-3.03,1.19-6.06,1.83-9.081c1.25-6.042,2.49-12.093,3.83-18.117 c2.63-12.056,5.47-24.066,8.27-36.085l4.21-18.033l4.33-17.996c0.44-1.826,0.88-3.642,1.32-5.467 c0.84-3.475,1.69-6.95,2.55-10.425c1.65-6.691,3.33-13.372,5.04-20.044c1.53-5.977,7.99-9.675,14.44-8.266 c1.2,0.259,2.32,0.686,3.33,1.242C159.91,263.694,162.33,268.569,161.08,273.434z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A3A3A3"
    },
    cx: 160.018,
    cy: 267.3,
    rx: 21.649,
    ry: 20.935
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M168.17,313.726l2.34,9.397c0.632,2.521,1.202,5.038,1.787,7.562 c1.463-9.177,2.447-18.437,3.556-27.72c0.015-0.122,0.076-0.214,0.155-0.284c-0.001-0.005-0.008-0.028-0.008-0.028 s6.85-3.549,11.52-5.931c-0.74-3.707-1.5-7.395-2.28-11.083l-23.87,2.558c1.44,5.384,2.89,10.759,4.34,16.115L168.17,313.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M155.41,292.32l0.59-5.495l-23.32,1.529c-0.86,3.475-1.71,6.95-2.55,10.425 l23.16,0.454L155.41,292.32z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M151.5,199.794c0.599-0.044,11.333,3.552,11.333,3.552l2.833-3.552c0,0,5,0.154,6.667,2.471 c1.667,2.317,15,87.88,15,87.88l-55.667,1.081l10.167-87.263C141.833,203.964,145.167,200.257,151.5,199.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M144.667,230.065l4.333,0.579l1.833-14.17v74.289l-17.5,0.463l5.833-53.439 C139.167,237.788,145.667,229.602,144.667,230.065z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156,286.824l0.12-0.102l-6.67-7.451c-0.02-0.028-0.03-0.056-0.05-0.074l-1.24,1.094 c-2.46,2.159-3.11,5.412-1.91,8.155c0.08,0.056,0.16,0.13,0.25,0.232C149,291.69,156,286.824,156,286.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M159.76,283.535l110.74-96.792l0.29-0.315l-7.23-7.497c-0.5,0.26-0.97,0.593-1.4,0.973 l-109.17,96.125c0.11,0.093,0.22,0.176,0.31,0.278L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M156.12,286.723l3.64-3.188l-6.46-7.228c-0.09-0.102-0.2-0.185-0.31-0.278l-3.59,3.169 c0.02,0.018,0.03,0.046,0.05,0.074L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M263.5,178.866l0.06,0.065c0.16-0.102,0.33-0.195,0.5-0.269L263.5,178.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M272.87,175.372l-7.73,2.882l-0.97,0.361l-0.11,0.046c-0.17,0.074-0.34,0.167-0.5,0.269 l7.23,7.497l4.06-4.402l1.98-2.141C274.74,178.217,273.55,176.614,272.87,175.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885l8.42-9.128l-12.38,4.615C273.55,176.614,274.74,178.217,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD6F2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463l3.51-3.086 c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463 l3.51-3.086c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026c0.95,1.779,1.07,3.827,0.38,5.662l3.73-6.311c-0.8-0.501-1.51-1.001-2.13-1.492 L274.85,182.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026l-4.06,4.402l3.21,3.327l1.23-2.067C275.92,185.853,275.8,183.805,274.85,182.026z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA64D"
    },
    d: "M276.83,179.885l-1.98,2.141l-4.06,4.402l3.21,3.327l1.23-2.067l3.73-6.311 C278.16,180.877,277.45,180.376,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M184.656,253.887c2.063,0.736,2.168,2.286,1.584,3.328c-0.723,0.122-0.77-1.47-1.358-1.879 c-0.889-0.824-2.555,0.673-4.429,0.673c-0.49,0.001-0.351-2.761-0.351-2.761c1.489-1.27,2.978-2.541,4.467-3.811 c0.148-0.127,0.318-0.261,0.52-0.261c0.148,0,0.283,0.075,0.409,0.148c1.191,0.697,2.295,1.521,3.286,2.449"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M185.68,251.632c1.598,1.082,2.505,2.981,2.294,4.805c-0.048,0.417-0.538,0.938-0.822,0.611 c0,0-0.872-3.414-2.545-2.774s-0.335-1.667-0.335-1.667L185.68,251.632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M188.13,251.621c1.397,1.166,1.476,3.432,0.162,4.679c0,0-0.466,0.552-0.717-0.223 c-0.251-0.775-2.361-3.372-2.361-3.372l0.042-1.144l1.442-0.426L188.13,251.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M187.276,252.187c2.35-0.161,3.647,2.319,4.09,1.911c0.443-0.408-0.87-2.465-1.979-3.238 c-1.11-0.773-2.366-1.632-3.754-1.632c-0.357,0-0.671,0.705-0.671,0.88C184.962,250.281,187.276,252.187,187.276,252.187z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M151.292,211.453l-1.567,5.182l-1.553,5.275c-1.007,3.505-1.937,6.994-2.674,10.425 c-0.757,3.42-1.298,6.807-1.5,9.943c-0.085,1.565-0.084,3.062,0.034,4.413c0.137,1.344,0.356,2.556,0.699,3.495 c0.358,0.939,0.737,1.65,1.264,2.285c0.545,0.604,1.288,1.203,2.366,1.686c1.066,0.488,2.412,0.885,3.914,1.121 c1.518,0.24,3.16,0.337,4.876,0.372c3.44,0.023,7.116-0.327,10.855-0.792c3.75-0.465,7.563-1.107,11.501-1.639l0.017-0.002 c0.872-0.118,1.674,0.493,1.792,1.365c0.08,0.589-0.175,1.147-0.616,1.483c-3.221,2.444-6.665,4.554-10.314,6.408 c-3.659,1.836-7.527,3.409-11.778,4.443c-2.13,0.522-4.365,0.863-6.724,1.023c-2.37,0.101-4.898-0.017-7.543-0.657 c-2.622-0.645-5.419-1.818-7.823-3.742c-2.41-1.904-4.341-4.407-5.613-6.982c-1.299-2.579-2.011-5.176-2.426-7.662 c-0.422-2.489-0.545-4.881-0.493-7.189c0.087-4.616,0.837-8.913,1.835-13.04c1.032-4.119,2.368-8.057,3.947-11.86 c0.796-1.899,1.633-3.772,2.575-5.598c0.468-0.914,0.936-1.827,1.437-2.73c0.526-0.915,0.999-1.757,1.63-2.753 c1.962-3.096,6.063-4.016,9.159-2.054c2.574,1.631,3.644,4.74,2.804,7.522L151.292,211.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M165.256,190.85h-4.014c-10.666,0-19.392-8.726-19.392-19.392v-0.165 c0-6.711,5.491-12.202,12.202-12.202h7.19c6.711,0,12.202,5.491,12.202,12.202v11.369 C173.443,187.165,169.759,190.85,165.256,190.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M145.799,201.209c-2.209,1.055-5.154,2.729-7.028,5.396c4.15-1.055,10.174,0.496,13.186,5.458 c0.335,1.303,1.473-7.195,1.473-7.195L145.799,201.209z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "174.44,433.119 174.667,414.487 187.205,415.335 183.651,430.807 189.919,432.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "102.783,432.063 103.861,413.263 117.428,413.958 112.88,429.613 119.602,431.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M138.77,206.605c-2.145,2.494-9.645,20.217-9.645,20.217L149,230.644l5.75-22.935l-10.625-2.548 L138.77,206.605z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M240.204,222.1c-0.159,0.069-0.339,0.1-0.525,0.083l-6.163-0.582 c-0.549-0.052-0.949-0.507-0.893-1.016c0.055-0.509,0.546-0.88,1.096-0.828l6.163,0.582c0.549,0.052,0.949,0.507,0.893,1.016 C240.738,221.691,240.512,221.967,240.204,222.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M239.459,223.832c-0.172,0.075-0.37,0.105-0.573,0.077l-5.237-0.729 c-0.546-0.076-0.922-0.548-0.84-1.054c0.082-0.507,0.59-0.856,1.137-0.779l5.237,0.729c0.546,0.076,0.922,0.548,0.84,1.054 C239.972,223.449,239.751,223.705,239.459,223.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M238.577,225.431c-0.182,0.079-0.391,0.108-0.604,0.073l-4.342-0.735 c-0.543-0.092-0.903-0.575-0.805-1.078c0.099-0.504,0.618-0.838,1.163-0.745l4.342,0.734c0.543,0.092,0.903,0.575,0.805,1.078 C239.076,225.065,238.86,225.308,238.577,225.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M237.513,226.534c-0.162,0.07-0.346,0.101-0.536,0.082l-3.025-0.316 c-0.549-0.057-0.944-0.516-0.882-1.025c0.062-0.509,0.557-0.874,1.105-0.817l3.025,0.316c0.549,0.057,0.944,0.516,0.882,1.024 C238.042,226.13,237.817,226.402,237.513,226.534z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M155.333,170.12c0,0,3.333-0.455,3.333-4.016c0-3.561,0-5.077,0-5.077H141.25 c0,0-2.417,2.576-2.583,10.381c-0.167,7.805,8.146,16.898,12.583,16.898c0-0.739,0.167-10.836,0.167-10.836L155.333,170.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M151.458,180.835L151.458,180.835c-1.26,0-2.292-1.031-2.292-2.292v-3.216 c0-1.26,1.031-2.292,2.292-2.292l0,0c1.26,0,2.292,1.031,2.292,2.292v3.216C153.75,179.804,152.719,180.835,151.458,180.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF4040",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M167.083,172.785 c-0.396,1.564,2.25,8.398,2.25,8.398H166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M163.417,175.179c0,0.906-0.793,1.641-1.771,1.641s-1.771-0.735-1.771-1.641 c0-0.906,0.793-1.641,1.771-1.641S163.417,174.272,163.417,175.179z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#221E28"
    },
    cx: 171.313,
    cy: 175.179,
    rx: 1.771,
    ry: 1.641
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.063,170.584 c0,0-2.188-1.084-5.813,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M168.563,170.468 c0,0,3.25-0.753,4.688,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.375,183.152h7.125c0,0-0.125,4.286-3.688,4.286S163.375,183.152,163.375,183.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M153.792,178.48L153.792,178.48c-0.848,0-1.542-0.694-1.542-1.542v-6.261 c0-0.848,0.694-1.542,1.542-1.542l0,0c0.848,0,1.542,0.694,1.542,1.542v6.261C155.333,177.786,154.64,178.48,153.792,178.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M141.25,161.027c0,0,1.083-4.942,8.75-5.02c7.667-0.077,14.5,0,16.417,0 c5.667,0,5.833-1.313,5.833-2.008c4.667,0,6.75,8.495-2.5,8.495s-14.667,0-14.667,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M165.07,196.149c-10.638-1.788-10.777-10.008-9.826-7.775c0.963,2.224,7.761,2.446,9.141,2.465 L165.07,196.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.417,175.321c0.814,0,0.816-1.173,0-1.173C161.602,174.148,161.601,175.321,162.417,175.321 L162.417,175.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.917,175.321c0.814,0,0.816-1.173,0-1.173C171.102,174.148,171.101,175.321,171.917,175.321 L171.917,175.321z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M173.532,206.564l0.039,0.985c0.029,0.383,0.042,0.758,0.084,1.148 c0.064,0.771,0.134,1.552,0.24,2.326c0.206,1.55,0.468,3.086,0.846,4.568c0.358,1.495,0.824,2.912,1.35,4.285 c0.314,0.647,0.551,1.355,0.914,1.954l0.481,0.944l0.549,0.875c1.475,2.333,3.342,4.125,5.659,5.384 c2.317,1.246,5.152,2.01,8.324,2.24c3.154,0.261,6.615-0.054,10.091-0.601c1.74-0.325,3.504-0.602,5.271-1.063l2.659-0.629 c0.882-0.259,1.758-0.533,2.65-0.779c7.116-2.043,14.176-4.791,21.401-7.491l0.028-0.01c0.9-0.336,1.924,0.067,2.287,0.901 c0.29,0.667,0.068,1.408-0.492,1.85c-6.032,4.749-12.601,8.949-19.816,12.415c-0.901,0.437-1.818,0.846-2.73,1.27l-2.84,1.125 c-0.96,0.359-1.884,0.779-2.881,1.086l-2.995,0.911c-0.987,0.327-2.032,0.556-3.081,0.784c-1.053,0.219-2.078,0.498-3.163,0.661 c-1.089,0.159-2.186,0.296-3.285,0.427c-1.098,0.133-2.26,0.111-3.393,0.164c-1.129,0.075-2.308-0.031-3.482-0.11 c-0.588-0.046-1.173-0.073-1.764-0.143l-1.785-0.311c-0.595-0.111-1.193-0.209-1.787-0.34l-1.77-0.541 c-0.586-0.195-1.185-0.35-1.759-0.589l-1.711-0.757c-2.286-1.016-4.36-2.437-6.262-3.987c-0.875-0.828-1.778-1.66-2.555-2.552 c-0.748-0.905-1.545-1.802-2.154-2.763c-2.648-3.79-4.19-7.889-5.135-11.919c-0.459-2.026-0.809-4.046-0.957-6.074 c-0.084-1.014-0.146-2.027-0.155-3.051c-0.012-0.508,0.008-1.031,0.013-1.546c0.02-0.552,0.034-0.994,0.087-1.709 c0.245-3.314,3.342-5.817,6.919-5.59c3.337,0.212,5.912,2.725,6.043,5.753L173.532,206.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M172.333,202.265c1.542,1.043,7.417,22.009,7.417,22.009l-6.875,2.664L169.5,204.35 L172.333,202.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18151C"
    },
    d: "M170.583,170.294c0,0,3.333-0.463,3.333-4.093s0-5.174,0-5.174H156.5c0,0-2.417,2.626-2.583,10.58 c-0.167,7.954,8.146,17.221,12.583,17.221c0-0.753,0.167-11.043,0.167-11.043L170.583,170.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M159.24,213.45c-4.24,0.398-8.02-2.456-8.46-6.376c-0.05-0.482-0.05-1.001,0-1.464l2.17-19.535 c0.31-2.817,3.03-4.865,6.06-4.578c2.66,0.26,4.68,2.206,4.94,4.578l0.53,4.763l0.59,5.31l1.05,9.461 C166.55,209.539,163.47,213.042,159.24,213.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M170.91,216.84c-0.326-1.573-0.692-3.144-1.109-4.731c-0.205-0.794-0.426-1.589-0.667-2.403 l-0.377-1.237l-0.212-0.65l-0.12-0.352l-0.162-0.445c-0.54-1.3-1.304-2.455-2.222-3.463c-1.66-0.235-3.324-0.446-4.997-0.588 c-4.875-0.416-9.922-0.628-14.74,0.303c-3.181,3.286-4.317,8.062-2.488,12.465c0,0-0.009-0.035,0.003-0.011l0.036,0.07 l0.077,0.154l0.171,0.365l0.354,0.803c0.236,0.549,0.473,1.122,0.699,1.705c0.458,1.161,0.891,2.359,1.296,3.57 c0.812,2.423,1.524,4.902,2.121,7.401c1.18,5.001,1.97,10.094,2.17,15.158c0.106,2.532,0.109,5.065-0.08,7.568 c-0.171,2.507-0.466,5.002-0.961,7.448c-0.91,4.921-2.571,9.656-4.804,14.176l-0.124,0.249c-1.896,3.826-0.429,8.445,3.553,10.674 c4.28,2.396,9.846,1.122,12.431-2.844c3.628-5.567,6.541-11.586,8.489-17.82c1.018-3.111,1.785-6.273,2.387-9.45 c0.62-3.179,1.005-6.375,1.251-9.571c0.503-6.398,0.282-12.776-0.439-19.096C172.076,223.128,171.565,219.984,170.91,216.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M195.57,359.81c0.02,6.839-0.57,13.65-1.34,20.359l-0.73,5.004c-0.25,1.659-0.45,3.336-0.79,4.976 c-0.64,3.281-1.2,6.589-1.91,9.841c-1.34,6.524-2.98,12.946-4.67,19.349c-0.76,2.845-3.85,4.578-6.92,3.883 c-1.99-0.454-3.47-1.816-4.07-3.494c-0.24-0.658-0.34-1.371-0.27-2.094v-0.037c1.17-12.974,2.38-25.845,2.65-38.495 c0.25-12.64-0.69-24.955-2.94-37.336c-0.57-3.104-1.23-6.209-1.87-9.304c-0.74-3.123-1.42-6.227-2.2-9.341l-2.34-9.397 l-2.46-9.415c-1.45-5.356-2.9-10.731-4.34-16.115c-0.75-2.762-1.49-5.514-2.22-8.285v-0.009c-1.2-4.513-2.39-9.035-3.57-13.557 c-0.45-1.714-0.46-3.438-0.09-5.06c0.95-4.254,4.46-7.84,9.32-8.915c6.71-1.501,13.46,2.326,15.08,8.553 c0.03,0.111,0.07,0.278,0.09,0.398c1.79,8.09,3.55,16.18,5.26,24.316c0.78,3.688,1.54,7.376,2.28,11.083 c0.22,1.029,0.42,2.057,0.63,3.095l1.9,9.739c0.62,3.253,1.2,6.542,1.78,9.814c0.54,3.29,1.01,6.626,1.52,9.934 c0.42,3.345,0.86,6.691,1.21,10.064l0.44,5.087l0.21,2.539l0.12,2.567l0.23,5.115C195.59,356.381,195.57,358.096,195.57,359.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M161.08,273.434c-0.03,0.111-0.08,0.269-0.11,0.38c-0.6,2.029-1.2,4.059-1.82,6.088v0.009 c-1.23,4.142-2.48,8.275-3.74,12.408c-0.7,2.307-1.41,4.606-2.12,6.913c-1.03,3.364-2.07,6.719-3.12,10.073l-5.52,17.718 l-5.64,17.69c-3.77,11.787-7.5,23.584-11.44,35.334c-1.94,5.884-3.99,11.741-6.02,17.598c-1.01,2.938-2.04,5.866-3.11,8.785 c-1.05,2.919-2.1,5.838-3.21,8.748c-1,2.65-4.14,4.05-7.01,3.114c-2.55-0.834-4.02-3.234-3.6-5.625 c0.54-3.049,1.14-6.079,1.72-9.109c0.58-3.03,1.19-6.06,1.83-9.081c1.25-6.042,2.49-12.093,3.83-18.117 c2.63-12.056,5.47-24.066,8.27-36.085l4.21-18.033l4.33-17.996c0.44-1.826,0.88-3.642,1.32-5.467 c0.84-3.475,1.69-6.95,2.55-10.425c1.65-6.691,3.33-13.372,5.04-20.044c1.53-5.977,7.99-9.675,14.44-8.266 c1.2,0.259,2.32,0.686,3.33,1.242C159.91,263.694,162.33,268.569,161.08,273.434z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A3A3A3"
    },
    cx: 160.018,
    cy: 267.3,
    rx: 21.649,
    ry: 20.935
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M168.17,313.726l2.34,9.397c0.632,2.521,1.202,5.038,1.787,7.562 c1.463-9.177,2.447-18.437,3.556-27.72c0.015-0.122,0.076-0.214,0.155-0.284c-0.001-0.005-0.008-0.028-0.008-0.028 s6.85-3.549,11.52-5.931c-0.74-3.707-1.5-7.395-2.28-11.083l-23.87,2.558c1.44,5.384,2.89,10.759,4.34,16.115L168.17,313.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M155.41,292.32l0.59-5.495l-23.32,1.529c-0.86,3.475-1.71,6.95-2.55,10.425 l23.16,0.454L155.41,292.32z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M151.5,199.794c0.599-0.044,11.333,3.552,11.333,3.552l2.833-3.552c0,0,5,0.154,6.667,2.471 c1.667,2.317,15,87.88,15,87.88l-55.667,1.081l10.167-87.263C141.833,203.964,145.167,200.257,151.5,199.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M144.667,230.065l4.333,0.579l1.833-14.17v74.289l-17.5,0.463l5.833-53.439 C139.167,237.788,145.667,229.602,144.667,230.065z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156,286.824l0.12-0.102l-6.67-7.451c-0.02-0.028-0.03-0.056-0.05-0.074l-1.24,1.094 c-2.46,2.159-3.11,5.412-1.91,8.155c0.08,0.056,0.16,0.13,0.25,0.232C149,291.69,156,286.824,156,286.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M159.76,283.535l110.74-96.792l0.29-0.315l-7.23-7.497c-0.5,0.26-0.97,0.593-1.4,0.973 l-109.17,96.125c0.11,0.093,0.22,0.176,0.31,0.278L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M156.12,286.723l3.64-3.188l-6.46-7.228c-0.09-0.102-0.2-0.185-0.31-0.278l-3.59,3.169 c0.02,0.018,0.03,0.046,0.05,0.074L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M263.5,178.866l0.06,0.065c0.16-0.102,0.33-0.195,0.5-0.269L263.5,178.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M272.87,175.372l-7.73,2.882l-0.97,0.361l-0.11,0.046c-0.17,0.074-0.34,0.167-0.5,0.269 l7.23,7.497l4.06-4.402l1.98-2.141C274.74,178.217,273.55,176.614,272.87,175.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885l8.42-9.128l-12.38,4.615C273.55,176.614,274.74,178.217,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD6F2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463l3.51-3.086 c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463 l3.51-3.086c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026c0.95,1.779,1.07,3.827,0.38,5.662l3.73-6.311c-0.8-0.501-1.51-1.001-2.13-1.492 L274.85,182.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026l-4.06,4.402l3.21,3.327l1.23-2.067C275.92,185.853,275.8,183.805,274.85,182.026z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA64D"
    },
    d: "M276.83,179.885l-1.98,2.141l-4.06,4.402l3.21,3.327l1.23-2.067l3.73-6.311 C278.16,180.877,277.45,180.376,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M184.656,253.887c2.063,0.736,2.168,2.286,1.584,3.328c-0.723,0.122-0.77-1.47-1.358-1.879 c-0.889-0.824-2.555,0.673-4.429,0.673c-0.49,0.001-0.351-2.761-0.351-2.761c1.489-1.27,2.978-2.541,4.467-3.811 c0.148-0.127,0.318-0.261,0.52-0.261c0.148,0,0.283,0.075,0.409,0.148c1.191,0.697,2.295,1.521,3.286,2.449"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M185.68,251.632c1.598,1.082,2.505,2.981,2.294,4.805c-0.048,0.417-0.538,0.938-0.822,0.611 c0,0-0.872-3.414-2.545-2.774s-0.335-1.667-0.335-1.667L185.68,251.632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M188.13,251.621c1.397,1.166,1.476,3.432,0.162,4.679c0,0-0.466,0.552-0.717-0.223 c-0.251-0.775-2.361-3.372-2.361-3.372l0.042-1.144l1.442-0.426L188.13,251.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M187.276,252.187c2.35-0.161,3.647,2.319,4.09,1.911c0.443-0.408-0.87-2.465-1.979-3.238 c-1.11-0.773-2.366-1.632-3.754-1.632c-0.357,0-0.671,0.705-0.671,0.88C184.962,250.281,187.276,252.187,187.276,252.187z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M151.292,211.453l-1.567,5.182l-1.553,5.275c-1.007,3.505-1.937,6.994-2.674,10.425 c-0.757,3.42-1.298,6.807-1.5,9.943c-0.085,1.565-0.084,3.062,0.034,4.413c0.137,1.344,0.356,2.556,0.699,3.495 c0.358,0.939,0.737,1.65,1.264,2.285c0.545,0.604,1.288,1.203,2.366,1.686c1.066,0.488,2.412,0.885,3.914,1.121 c1.518,0.24,3.16,0.337,4.876,0.372c3.44,0.023,7.116-0.327,10.855-0.792c3.75-0.465,7.563-1.107,11.501-1.639l0.017-0.002 c0.872-0.118,1.674,0.493,1.792,1.365c0.08,0.589-0.175,1.147-0.616,1.483c-3.221,2.444-6.665,4.554-10.314,6.408 c-3.659,1.836-7.527,3.409-11.778,4.443c-2.13,0.522-4.365,0.863-6.724,1.023c-2.37,0.101-4.898-0.017-7.543-0.657 c-2.622-0.645-5.419-1.818-7.823-3.742c-2.41-1.904-4.341-4.407-5.613-6.982c-1.299-2.579-2.011-5.176-2.426-7.662 c-0.422-2.489-0.545-4.881-0.493-7.189c0.087-4.616,0.837-8.913,1.835-13.04c1.032-4.119,2.368-8.057,3.947-11.86 c0.796-1.899,1.633-3.772,2.575-5.598c0.468-0.914,0.936-1.827,1.437-2.73c0.526-0.915,0.999-1.757,1.63-2.753 c1.962-3.096,6.063-4.016,9.159-2.054c2.574,1.631,3.644,4.74,2.804,7.522L151.292,211.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M165.256,190.85h-4.014c-10.666,0-19.392-8.726-19.392-19.392v-0.165 c0-6.711,5.491-12.202,12.202-12.202h7.19c6.711,0,12.202,5.491,12.202,12.202v11.369 C173.443,187.165,169.759,190.85,165.256,190.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M145.799,201.209c-2.209,1.055-5.154,2.729-7.028,5.396c4.15-1.055,10.174,0.496,13.186,5.458 c0.335,1.303,1.473-7.195,1.473-7.195L145.799,201.209z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "174.44,433.119 174.667,414.487 187.205,415.335 183.651,430.807 189.919,432.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "102.783,432.063 103.861,413.263 117.428,413.958 112.88,429.613 119.602,431.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M138.77,206.605c-2.145,2.494-9.645,20.217-9.645,20.217L149,230.644l5.75-22.935l-10.625-2.548 L138.77,206.605z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M240.204,222.1c-0.159,0.069-0.339,0.1-0.525,0.083l-6.163-0.582 c-0.549-0.052-0.949-0.507-0.893-1.016c0.055-0.509,0.546-0.88,1.096-0.828l6.163,0.582c0.549,0.052,0.949,0.507,0.893,1.016 C240.738,221.691,240.512,221.967,240.204,222.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M239.459,223.832c-0.172,0.075-0.37,0.105-0.573,0.077l-5.237-0.729 c-0.546-0.076-0.922-0.548-0.84-1.054c0.082-0.507,0.59-0.856,1.137-0.779l5.237,0.729c0.546,0.076,0.922,0.548,0.84,1.054 C239.972,223.449,239.751,223.705,239.459,223.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M238.577,225.431c-0.182,0.079-0.391,0.108-0.604,0.073l-4.342-0.735 c-0.543-0.092-0.903-0.575-0.805-1.078c0.099-0.504,0.618-0.838,1.163-0.745l4.342,0.734c0.543,0.092,0.903,0.575,0.805,1.078 C239.076,225.065,238.86,225.308,238.577,225.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M237.513,226.534c-0.162,0.07-0.346,0.101-0.536,0.082l-3.025-0.316 c-0.549-0.057-0.944-0.516-0.882-1.025c0.062-0.509,0.557-0.874,1.105-0.817l3.025,0.316c0.549,0.057,0.944,0.516,0.882,1.024 C238.042,226.13,237.817,226.402,237.513,226.534z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M155.333,170.12c0,0,3.333-0.455,3.333-4.016c0-3.561,0-5.077,0-5.077H141.25 c0,0-2.417,2.576-2.583,10.381c-0.167,7.805,8.146,16.898,12.583,16.898c0-0.739,0.167-10.836,0.167-10.836L155.333,170.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M151.458,180.835L151.458,180.835c-1.26,0-2.292-1.031-2.292-2.292v-3.216 c0-1.26,1.031-2.292,2.292-2.292l0,0c1.26,0,2.292,1.031,2.292,2.292v3.216C153.75,179.804,152.719,180.835,151.458,180.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF4040",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M167.083,172.785 c-0.396,1.564,2.25,8.398,2.25,8.398H166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M163.417,175.179c0,0.906-0.793,1.641-1.771,1.641s-1.771-0.735-1.771-1.641 c0-0.906,0.793-1.641,1.771-1.641S163.417,174.272,163.417,175.179z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#221E28"
    },
    cx: 171.313,
    cy: 175.179,
    rx: 1.771,
    ry: 1.641
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.063,170.584 c0,0-2.188-1.084-5.813,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M168.563,170.468 c0,0,3.25-0.753,4.688,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.375,183.152h7.125c0,0-0.125,4.286-3.688,4.286S163.375,183.152,163.375,183.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M153.792,178.48L153.792,178.48c-0.848,0-1.542-0.694-1.542-1.542v-6.261 c0-0.848,0.694-1.542,1.542-1.542l0,0c0.848,0,1.542,0.694,1.542,1.542v6.261C155.333,177.786,154.64,178.48,153.792,178.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M141.25,161.027c0,0,1.083-4.942,8.75-5.02c7.667-0.077,14.5,0,16.417,0 c5.667,0,5.833-1.313,5.833-2.008c4.667,0,6.75,8.495-2.5,8.495s-14.667,0-14.667,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M165.07,196.149c-10.638-1.788-10.777-10.008-9.826-7.775c0.963,2.224,7.761,2.446,9.141,2.465 L165.07,196.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.417,175.321c0.814,0,0.816-1.173,0-1.173C161.602,174.148,161.601,175.321,162.417,175.321 L162.417,175.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.917,175.321c0.814,0,0.816-1.173,0-1.173C171.102,174.148,171.101,175.321,171.917,175.321 L171.917,175.321z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M173.532,206.564l0.039,0.985c0.029,0.383,0.042,0.758,0.084,1.148 c0.064,0.771,0.134,1.552,0.24,2.326c0.206,1.55,0.468,3.086,0.846,4.568c0.358,1.495,0.824,2.912,1.35,4.285 c0.314,0.647,0.551,1.355,0.914,1.954l0.481,0.944l0.549,0.875c1.475,2.333,3.342,4.125,5.659,5.384 c2.317,1.246,5.152,2.01,8.324,2.24c3.154,0.261,6.615-0.054,10.091-0.601c1.74-0.325,3.504-0.602,5.271-1.063l2.659-0.629 c0.882-0.259,1.758-0.533,2.65-0.779c7.116-2.043,14.176-4.791,21.401-7.491l0.028-0.01c0.9-0.336,1.924,0.067,2.287,0.901 c0.29,0.667,0.068,1.408-0.492,1.85c-6.032,4.749-12.601,8.949-19.816,12.415c-0.901,0.437-1.818,0.846-2.73,1.27l-2.84,1.125 c-0.96,0.359-1.884,0.779-2.881,1.086l-2.995,0.911c-0.987,0.327-2.032,0.556-3.081,0.784c-1.053,0.219-2.078,0.498-3.163,0.661 c-1.089,0.159-2.186,0.296-3.285,0.427c-1.098,0.133-2.26,0.111-3.393,0.164c-1.129,0.075-2.308-0.031-3.482-0.11 c-0.588-0.046-1.173-0.073-1.764-0.143l-1.785-0.311c-0.595-0.111-1.193-0.209-1.787-0.34l-1.77-0.541 c-0.586-0.195-1.185-0.35-1.759-0.589l-1.711-0.757c-2.286-1.016-4.36-2.437-6.262-3.987c-0.875-0.828-1.778-1.66-2.555-2.552 c-0.748-0.905-1.545-1.802-2.154-2.763c-2.648-3.79-4.19-7.889-5.135-11.919c-0.459-2.026-0.809-4.046-0.957-6.074 c-0.084-1.014-0.146-2.027-0.155-3.051c-0.012-0.508,0.008-1.031,0.013-1.546c0.02-0.552,0.034-0.994,0.087-1.709 c0.245-3.314,3.342-5.817,6.919-5.59c3.337,0.212,5.912,2.725,6.043,5.753L173.532,206.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M172.333,202.265c1.542,1.043,7.417,22.009,7.417,22.009l-6.875,2.664L169.5,204.35 L172.333,202.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18151C"
    },
    d: "M170.583,170.294c0,0,3.333-0.463,3.333-4.093s0-5.174,0-5.174H156.5c0,0-2.417,2.626-2.583,10.58 c-0.167,7.954,8.146,17.221,12.583,17.221c0-0.753,0.167-11.043,0.167-11.043L170.583,170.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M159.24,213.45c-4.24,0.398-8.02-2.456-8.46-6.376c-0.05-0.482-0.05-1.001,0-1.464l2.17-19.535 c0.31-2.817,3.03-4.865,6.06-4.578c2.66,0.26,4.68,2.206,4.94,4.578l0.53,4.763l0.59,5.31l1.05,9.461 C166.55,209.539,163.47,213.042,159.24,213.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M170.91,216.84c-0.326-1.573-0.692-3.144-1.109-4.731c-0.205-0.794-0.426-1.589-0.667-2.403 l-0.377-1.237l-0.212-0.65l-0.12-0.352l-0.162-0.445c-0.54-1.3-1.304-2.455-2.222-3.463c-1.66-0.235-3.324-0.446-4.997-0.588 c-4.875-0.416-9.922-0.628-14.74,0.303c-3.181,3.286-4.317,8.062-2.488,12.465c0,0-0.009-0.035,0.003-0.011l0.036,0.07 l0.077,0.154l0.171,0.365l0.354,0.803c0.236,0.549,0.473,1.122,0.699,1.705c0.458,1.161,0.891,2.359,1.296,3.57 c0.812,2.423,1.524,4.902,2.121,7.401c1.18,5.001,1.97,10.094,2.17,15.158c0.106,2.532,0.109,5.065-0.08,7.568 c-0.171,2.507-0.466,5.002-0.961,7.448c-0.91,4.921-2.571,9.656-4.804,14.176l-0.124,0.249c-1.896,3.826-0.429,8.445,3.553,10.674 c4.28,2.396,9.846,1.122,12.431-2.844c3.628-5.567,6.541-11.586,8.489-17.82c1.018-3.111,1.785-6.273,2.387-9.45 c0.62-3.179,1.005-6.375,1.251-9.571c0.503-6.398,0.282-12.776-0.439-19.096C172.076,223.128,171.565,219.984,170.91,216.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M195.57,359.81c0.02,6.839-0.57,13.65-1.34,20.359l-0.73,5.004c-0.25,1.659-0.45,3.336-0.79,4.976 c-0.64,3.281-1.2,6.589-1.91,9.841c-1.34,6.524-2.98,12.946-4.67,19.349c-0.76,2.845-3.85,4.578-6.92,3.883 c-1.99-0.454-3.47-1.816-4.07-3.494c-0.24-0.658-0.34-1.371-0.27-2.094v-0.037c1.17-12.974,2.38-25.845,2.65-38.495 c0.25-12.64-0.69-24.955-2.94-37.336c-0.57-3.104-1.23-6.209-1.87-9.304c-0.74-3.123-1.42-6.227-2.2-9.341l-2.34-9.397 l-2.46-9.415c-1.45-5.356-2.9-10.731-4.34-16.115c-0.75-2.762-1.49-5.514-2.22-8.285v-0.009c-1.2-4.513-2.39-9.035-3.57-13.557 c-0.45-1.714-0.46-3.438-0.09-5.06c0.95-4.254,4.46-7.84,9.32-8.915c6.71-1.501,13.46,2.326,15.08,8.553 c0.03,0.111,0.07,0.278,0.09,0.398c1.79,8.09,3.55,16.18,5.26,24.316c0.78,3.688,1.54,7.376,2.28,11.083 c0.22,1.029,0.42,2.057,0.63,3.095l1.9,9.739c0.62,3.253,1.2,6.542,1.78,9.814c0.54,3.29,1.01,6.626,1.52,9.934 c0.42,3.345,0.86,6.691,1.21,10.064l0.44,5.087l0.21,2.539l0.12,2.567l0.23,5.115C195.59,356.381,195.57,358.096,195.57,359.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M161.08,273.434c-0.03,0.111-0.08,0.269-0.11,0.38c-0.6,2.029-1.2,4.059-1.82,6.088v0.009 c-1.23,4.142-2.48,8.275-3.74,12.408c-0.7,2.307-1.41,4.606-2.12,6.913c-1.03,3.364-2.07,6.719-3.12,10.073l-5.52,17.718 l-5.64,17.69c-3.77,11.787-7.5,23.584-11.44,35.334c-1.94,5.884-3.99,11.741-6.02,17.598c-1.01,2.938-2.04,5.866-3.11,8.785 c-1.05,2.919-2.1,5.838-3.21,8.748c-1,2.65-4.14,4.05-7.01,3.114c-2.55-0.834-4.02-3.234-3.6-5.625 c0.54-3.049,1.14-6.079,1.72-9.109c0.58-3.03,1.19-6.06,1.83-9.081c1.25-6.042,2.49-12.093,3.83-18.117 c2.63-12.056,5.47-24.066,8.27-36.085l4.21-18.033l4.33-17.996c0.44-1.826,0.88-3.642,1.32-5.467 c0.84-3.475,1.69-6.95,2.55-10.425c1.65-6.691,3.33-13.372,5.04-20.044c1.53-5.977,7.99-9.675,14.44-8.266 c1.2,0.259,2.32,0.686,3.33,1.242C159.91,263.694,162.33,268.569,161.08,273.434z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#A3A3A3"
    },
    cx: 160.018,
    cy: 267.3,
    rx: 21.649,
    ry: 20.935
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M168.17,313.726l2.34,9.397c0.632,2.521,1.202,5.038,1.787,7.562 c1.463-9.177,2.447-18.437,3.556-27.72c0.015-0.122,0.076-0.214,0.155-0.284c-0.001-0.005-0.008-0.028-0.008-0.028 s6.85-3.549,11.52-5.931c-0.74-3.707-1.5-7.395-2.28-11.083l-23.87,2.558c1.44,5.384,2.89,10.759,4.34,16.115L168.17,313.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#A3A3A3"
    },
    d: "M155.41,292.32l0.59-5.495l-23.32,1.529c-0.86,3.475-1.71,6.95-2.55,10.425 l23.16,0.454L155.41,292.32z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M151.5,199.794c0.599-0.044,11.333,3.552,11.333,3.552l2.833-3.552c0,0,5,0.154,6.667,2.471 c1.667,2.317,15,87.88,15,87.88l-55.667,1.081l10.167-87.263C141.833,203.964,145.167,200.257,151.5,199.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251C33"
    },
    d: "M144.667,230.065l4.333,0.579l1.833-14.17v74.289l-17.5,0.463l5.833-53.439 C139.167,237.788,145.667,229.602,144.667,230.065z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156,286.824l0.12-0.102l-6.67-7.451c-0.02-0.028-0.03-0.056-0.05-0.074l-1.24,1.094 c-2.46,2.159-3.11,5.412-1.91,8.155c0.08,0.056,0.16,0.13,0.25,0.232C149,291.69,156,286.824,156,286.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M159.76,283.535l110.74-96.792l0.29-0.315l-7.23-7.497c-0.5,0.26-0.97,0.593-1.4,0.973 l-109.17,96.125c0.11,0.093,0.22,0.176,0.31,0.278L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M156.12,286.723l3.64-3.188l-6.46-7.228c-0.09-0.102-0.2-0.185-0.31-0.278l-3.59,3.169 c0.02,0.018,0.03,0.046,0.05,0.074L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M263.5,178.866l0.06,0.065c0.16-0.102,0.33-0.195,0.5-0.269L263.5,178.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M272.87,175.372l-7.73,2.882l-0.97,0.361l-0.11,0.046c-0.17,0.074-0.34,0.167-0.5,0.269 l7.23,7.497l4.06-4.402l1.98-2.141C274.74,178.217,273.55,176.614,272.87,175.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885l8.42-9.128l-12.38,4.615C273.55,176.614,274.74,178.217,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M156.12,286.723l-0.12,0.102c0,0-7,4.865-9.5,1.853c-0.09-0.102-0.17-0.176-0.25-0.232 c0.36,0.834,0.91,1.631,1.62,2.326c1.57,1.538,3.68,2.307,5.8,2.307c1.98,0,3.96-0.676,5.51-2.039l0.54-0.482 c-0.21-0.12-0.41-0.269-0.58-0.463L156.12,286.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9A2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD6F2F"
    },
    d: "M270.79,186.428l-0.29,0.315l-110.74,96.792l3.23,3.605c0.09,0.102,0.17,0.222,0.24,0.334 l109.95-96.82c0.96-0.853,1.65-1.872,2.05-2.965l-1.23,2.067L270.79,186.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463l3.51-3.086 c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#A3A3A3"
    },
    d: "M159.76,283.535l-3.64,3.188l3.02,3.373c0.17,0.195,0.37,0.343,0.58,0.463 l3.51-3.086c-0.07-0.111-0.15-0.232-0.24-0.334L159.76,283.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026c0.95,1.779,1.07,3.827,0.38,5.662l3.73-6.311c-0.8-0.501-1.51-1.001-2.13-1.492 L274.85,182.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB77A"
    },
    d: "M274.85,182.026l-4.06,4.402l3.21,3.327l1.23-2.067C275.92,185.853,275.8,183.805,274.85,182.026z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA64D"
    },
    d: "M276.83,179.885l-1.98,2.141l-4.06,4.402l3.21,3.327l1.23-2.067l3.73-6.311 C278.16,180.877,277.45,180.376,276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M276.83,179.885c0.62,0.491,1.33,0.992,2.13,1.492l6.29-10.62L276.83,179.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M184.656,253.887c2.063,0.736,2.168,2.286,1.584,3.328c-0.723,0.122-0.77-1.47-1.358-1.879 c-0.889-0.824-2.555,0.673-4.429,0.673c-0.49,0.001-0.351-2.761-0.351-2.761c1.489-1.27,2.978-2.541,4.467-3.811 c0.148-0.127,0.318-0.261,0.52-0.261c0.148,0,0.283,0.075,0.409,0.148c1.191,0.697,2.295,1.521,3.286,2.449"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M185.68,251.632c1.598,1.082,2.505,2.981,2.294,4.805c-0.048,0.417-0.538,0.938-0.822,0.611 c0,0-0.872-3.414-2.545-2.774s-0.335-1.667-0.335-1.667L185.68,251.632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M188.13,251.621c1.397,1.166,1.476,3.432,0.162,4.679c0,0-0.466,0.552-0.717-0.223 c-0.251-0.775-2.361-3.372-2.361-3.372l0.042-1.144l1.442-0.426L188.13,251.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M187.276,252.187c2.35-0.161,3.647,2.319,4.09,1.911c0.443-0.408-0.87-2.465-1.979-3.238 c-1.11-0.773-2.366-1.632-3.754-1.632c-0.357,0-0.671,0.705-0.671,0.88C184.962,250.281,187.276,252.187,187.276,252.187z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M151.292,211.453l-1.567,5.182l-1.553,5.275c-1.007,3.505-1.937,6.994-2.674,10.425 c-0.757,3.42-1.298,6.807-1.5,9.943c-0.085,1.565-0.084,3.062,0.034,4.413c0.137,1.344,0.356,2.556,0.699,3.495 c0.358,0.939,0.737,1.65,1.264,2.285c0.545,0.604,1.288,1.203,2.366,1.686c1.066,0.488,2.412,0.885,3.914,1.121 c1.518,0.24,3.16,0.337,4.876,0.372c3.44,0.023,7.116-0.327,10.855-0.792c3.75-0.465,7.563-1.107,11.501-1.639l0.017-0.002 c0.872-0.118,1.674,0.493,1.792,1.365c0.08,0.589-0.175,1.147-0.616,1.483c-3.221,2.444-6.665,4.554-10.314,6.408 c-3.659,1.836-7.527,3.409-11.778,4.443c-2.13,0.522-4.365,0.863-6.724,1.023c-2.37,0.101-4.898-0.017-7.543-0.657 c-2.622-0.645-5.419-1.818-7.823-3.742c-2.41-1.904-4.341-4.407-5.613-6.982c-1.299-2.579-2.011-5.176-2.426-7.662 c-0.422-2.489-0.545-4.881-0.493-7.189c0.087-4.616,0.837-8.913,1.835-13.04c1.032-4.119,2.368-8.057,3.947-11.86 c0.796-1.899,1.633-3.772,2.575-5.598c0.468-0.914,0.936-1.827,1.437-2.73c0.526-0.915,0.999-1.757,1.63-2.753 c1.962-3.096,6.063-4.016,9.159-2.054c2.574,1.631,3.644,4.74,2.804,7.522L151.292,211.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M165.256,190.85h-4.014c-10.666,0-19.392-8.726-19.392-19.392v-0.165 c0-6.711,5.491-12.202,12.202-12.202h7.19c6.711,0,12.202,5.491,12.202,12.202v11.369 C173.443,187.165,169.759,190.85,165.256,190.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M145.799,201.209c-2.209,1.055-5.154,2.729-7.028,5.396c4.15-1.055,10.174,0.496,13.186,5.458 c0.335,1.303,1.473-7.195,1.473-7.195L145.799,201.209z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "174.44,433.119 174.667,414.487 187.205,415.335 183.651,430.807 189.919,432.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#221E28"
    },
    points: "102.783,432.063 103.861,413.263 117.428,413.958 112.88,429.613 119.602,431.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342747"
    },
    d: "M138.77,206.605c-2.145,2.494-9.645,20.217-9.645,20.217L149,230.644l5.75-22.935l-10.625-2.548 L138.77,206.605z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M240.204,222.1c-0.159,0.069-0.339,0.1-0.525,0.083l-6.163-0.582 c-0.549-0.052-0.949-0.507-0.893-1.016c0.055-0.509,0.546-0.88,1.096-0.828l6.163,0.582c0.549,0.052,0.949,0.507,0.893,1.016 C240.738,221.691,240.512,221.967,240.204,222.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M239.459,223.832c-0.172,0.075-0.37,0.105-0.573,0.077l-5.237-0.729 c-0.546-0.076-0.922-0.548-0.84-1.054c0.082-0.507,0.59-0.856,1.137-0.779l5.237,0.729c0.546,0.076,0.922,0.548,0.84,1.054 C239.972,223.449,239.751,223.705,239.459,223.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M238.577,225.431c-0.182,0.079-0.391,0.108-0.604,0.073l-4.342-0.735 c-0.543-0.092-0.903-0.575-0.805-1.078c0.099-0.504,0.618-0.838,1.163-0.745l4.342,0.734c0.543,0.092,0.903,0.575,0.805,1.078 C239.076,225.065,238.86,225.308,238.577,225.431z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD5954"
    },
    d: "M237.513,226.534c-0.162,0.07-0.346,0.101-0.536,0.082l-3.025-0.316 c-0.549-0.057-0.944-0.516-0.882-1.025c0.062-0.509,0.557-0.874,1.105-0.817l3.025,0.316c0.549,0.057,0.944,0.516,0.882,1.024 C238.042,226.13,237.817,226.402,237.513,226.534z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M155.333,170.12c0,0,3.333-0.455,3.333-4.016c0-3.561,0-5.077,0-5.077H141.25 c0,0-2.417,2.576-2.583,10.381c-0.167,7.805,8.146,16.898,12.583,16.898c0-0.739,0.167-10.836,0.167-10.836L155.333,170.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M151.458,180.835L151.458,180.835c-1.26,0-2.292-1.031-2.292-2.292v-3.216 c0-1.26,1.031-2.292,2.292-2.292l0,0c1.26,0,2.292,1.031,2.292,2.292v3.216C153.75,179.804,152.719,180.835,151.458,180.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF4040",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M167.083,172.785 c-0.396,1.564,2.25,8.398,2.25,8.398H166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M163.417,175.179c0,0.906-0.793,1.641-1.771,1.641s-1.771-0.735-1.771-1.641 c0-0.906,0.793-1.641,1.771-1.641S163.417,174.272,163.417,175.179z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#221E28"
    },
    cx: 171.313,
    cy: 175.179,
    rx: 1.771,
    ry: 1.641
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.063,170.584 c0,0-2.188-1.084-5.813,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#18151C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M168.563,170.468 c0,0,3.25-0.753,4.688,0.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.375,183.152h7.125c0,0-0.125,4.286-3.688,4.286S163.375,183.152,163.375,183.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M153.792,178.48L153.792,178.48c-0.848,0-1.542-0.694-1.542-1.542v-6.261 c0-0.848,0.694-1.542,1.542-1.542l0,0c0.848,0,1.542,0.694,1.542,1.542v6.261C155.333,177.786,154.64,178.48,153.792,178.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221E28"
    },
    d: "M141.25,161.027c0,0,1.083-4.942,8.75-5.02c7.667-0.077,14.5,0,16.417,0 c5.667,0,5.833-1.313,5.833-2.008c4.667,0,6.75,8.495-2.5,8.495s-14.667,0-14.667,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF4040"
    },
    d: "M165.07,196.149c-10.638-1.788-10.777-10.008-9.826-7.775c0.963,2.224,7.761,2.446,9.141,2.465 L165.07,196.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.417,175.321c0.814,0,0.816-1.173,0-1.173C161.602,174.148,161.601,175.321,162.417,175.321 L162.417,175.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.917,175.321c0.814,0,0.816-1.173,0-1.173C171.102,174.148,171.101,175.321,171.917,175.321 L171.917,175.321z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M443,60.5c-5.238,0-9.5-4.262-9.5-9.5s4.262-9.5,9.5-9.5c5.238,0,9.5,4.262,9.5,9.5 S448.238,60.5,443,60.5z M443,44.5c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5s6.5-2.916,6.5-6.5S446.584,44.5,443,44.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M372,79.166c-2.113,0-3.833-1.719-3.833-3.833S369.887,71.5,372,71.5 c2.113,0,3.833,1.72,3.833,3.834S374.113,79.166,372,79.166z M372,74.5c-0.459,0-0.833,0.374-0.833,0.834 c0,0.459,0.374,0.833,0.833,0.833s0.833-0.373,0.833-0.833C372.833,74.874,372.459,74.5,372,74.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M49,246.5c-5.606,0-10.167-4.561-10.167-10.167S43.394,226.167,49,226.167 s10.167,4.561,10.167,10.167S54.606,246.5,49,246.5z M49,229.167c-3.952,0-7.167,3.215-7.167,7.167 c0,3.952,3.215,7.167,7.167,7.167s7.167-3.215,7.167-7.167C56.167,232.382,52.952,229.167,49,229.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4B9FD"
    },
    d: "M89.334,186.5c-2.481,0-4.5-2.019-4.5-4.5s2.019-4.5,4.5-4.5c2.481,0,4.5,2.019,4.5,4.5 S91.815,186.5,89.334,186.5z M89.334,180.5c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5c0.827,0,1.5-0.673,1.5-1.5 S90.161,180.5,89.334,180.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C4B9FD"
    },
    cx: 70.667,
    cy: 74,
    r: 7.667
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C4B9FD"
    },
    cx: 440.667,
    cy: 191.333,
    r: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    style: {
      fill: "#1D262C"
    },
    d: "M260.104,471.758c-0.432,0.443-0.803,0.931-1.108,1.453l-0.465-0.241 c-0.067-0.298-0.349-0.503-0.659-0.466c-0.331,0.039-0.568,0.339-0.529,0.67c0.039,0.331,0.339,0.568,0.67,0.529 c0.066-0.008,0.127-0.026,0.184-0.052l0.451,0.234c-0.251,0.554-0.433,1.139-0.539,1.744l0.747,0.132 c0.23-1.306,0.85-2.507,1.792-3.473L260.104,471.758z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    style: {
      fill: "#1D262C"
    },
    d: "M265.592,469.456c-0.171,0-0.341,0.006-0.51,0.017l-0.074-0.626 c0.188-0.149,0.296-0.389,0.266-0.645c-0.046-0.393-0.402-0.674-0.795-0.628c-0.393,0.046-0.674,0.402-0.628,0.795 c0.03,0.254,0.189,0.461,0.404,0.564l0.074,0.624c-0.714,0.116-1.403,0.332-2.06,0.646l0.327,0.684 c0.934-0.447,1.942-0.673,2.995-0.673c0.496,0,0.993,0.053,1.475,0.158l0.161-0.741 C266.692,469.515,266.142,469.456,265.592,469.456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    style: {
      fill: "#1D262C"
    },
    d: "M272.194,472.004c0.331-0.04,0.566-0.341,0.526-0.672 c-0.04-0.331-0.341-0.566-0.672-0.526c-0.309,0.038-0.535,0.304-0.53,0.609l-0.416,0.363c-0.418-0.43-0.889-0.813-1.408-1.139 l-0.404,0.641c1.134,0.715,2.021,1.726,2.563,2.925l0.69-0.313c-0.251-0.554-0.567-1.072-0.942-1.545l0.402-0.351 C272.065,472.009,272.129,472.012,272.194,472.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    style: {
      fill: "#1D262C"
    },
    d: "M265.044,479.665c-0.386,0.023-0.775,0.035-1.157,0.035 c-0.88,0-1.733-0.061-2.478-0.179c-0.39-0.062-0.846-0.155-1.27-0.292c1.046,1.861,3.069,3.125,5.388,3.125 c2.855,0,5.262-1.916,5.95-4.504c-0.682,0.449-1.505,0.825-2.459,1.123C267.839,479.34,266.463,479.579,265.044,479.665z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    style: {
      fill: "#1D262C"
    },
    d: "M265.592,470.973c-3.352,0-6.08,2.666-6.08,5.943 c0,0.426,0.046,0.849,0.137,1.261c0.673,0.483,2.706,0.89,5.348,0.731c2.879-0.173,5.297-0.957,6.672-2.159 c-0.006-0.195-0.021-0.39-0.045-0.582C271.244,473.206,268.65,470.973,265.592,470.973z M263.432,477.487 c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85c1.02,0,1.85,0.83,1.85,1.85 C265.282,476.658,264.452,477.487,263.432,477.487z M268.17,476.579c-0.75,0-1.36-0.61-1.36-1.36s0.61-1.361,1.36-1.361 c0.75,0,1.361,0.61,1.361,1.361S268.92,476.579,268.17,476.579z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    style: {
      fill: "#1D262C"
    },
    d: "M281.595,472.84c-0.295-0.116-0.805-0.309-1.382-0.237 c-0.551,0.069-0.844,0.341-0.844,1.007v0.866h2.228v1.717h-2.228v5.455h-1.932v-5.455h-1.34v-1.717h1.34v-0.888 c0-1.68,0.896-2.783,2.568-2.783c0.643,0,1.157,0.122,1.59,0.308L281.595,472.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    style: {
      fill: "#1D262C"
    },
    d: "M286.298,476.172c-0.177-0.03-0.358-0.046-0.526-0.046 c-0.896,0-1.51,0.548-1.51,1.614v3.908h-1.932v-7.172h1.873v0.785c0.451-0.673,1.14-0.977,2.021-0.977 c0.414,0,0.848,0.128,1.094,0.337L286.298,476.172z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    style: {
      fill: "#1D262C"
    },
    d: "M293.965,478.05c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.133,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C292.544,474.283,293.958,475.815,293.965,478.05z  M288.851,477.384h3.175c-0.177-0.918-0.733-1.436-1.562-1.436C289.554,475.948,289.021,476.496,288.851,477.384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      fill: "#1D262C"
    },
    d: "M301.618,478.05c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.814-0.688l1.132,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C300.197,474.283,301.611,475.815,301.618,478.05z  M296.504,477.384h3.175c-0.178-0.918-0.733-1.436-1.562-1.436C297.207,475.948,296.674,476.496,296.504,477.384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      fill: "#1D262C"
    },
    d: "M309.964,478.057c0,2.154-1.495,3.775-3.471,3.775 c-0.962,0-1.643-0.378-2.109-0.933v3.708h-1.924v-10.133h1.887v0.792c0.466-0.585,1.155-0.984,2.139-0.984 C308.469,474.283,309.964,475.903,309.964,478.057z M304.287,478.057c0,1.132,0.748,1.976,1.843,1.976 c1.14,0,1.85-0.881,1.85-1.976c0-1.095-0.71-1.976-1.85-1.976C305.035,476.081,304.287,476.925,304.287,478.057z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#1D262C"
    },
    d: "M313.068,472.129c0,0.696-0.54,1.229-1.236,1.229c-0.696,0-1.229-0.533-1.229-1.229 c0-0.696,0.533-1.243,1.229-1.243C312.527,470.885,313.068,471.433,313.068,472.129z M312.809,481.647h-1.932v-7.172h1.932 V481.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    style: {
      fill: "#1D262C"
    },
    d: "M316.032,477.029l2.701-2.554h2.368l-3.479,3.375l3.501,3.797h-2.376l-2.716-2.901 v2.901H314.1v-10.658h1.932V477.029z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M184.412,481.582v-1.055c-0.527,0.718-1.391,1.23-2.387,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.816,0.469,2.387,1.245v-3.765h1.099v9.77H184.412z M184.412,479.663v-3.208 c-0.395-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.85,2.724,2.27,2.724 C183.168,480.776,184.017,480.279,184.412,479.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M186.932,478.037c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.805,0,1.626-0.322,2.182-0.894l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C188.44,481.758,186.932,480.249,186.932,478.037z M190.403,475.24c-1.509,0-2.256,1.274-2.314,2.358h4.643 C192.718,476.543,192.015,475.24,190.403,475.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M194.607,480.644l0.571-0.791c0.469,0.542,1.362,1.011,2.329,1.011c1.084,0,1.67-0.513,1.67-1.216 c0-1.714-4.38-0.659-4.38-3.281c0-1.098,0.952-2.036,2.636-2.036c1.201,0,2.051,0.454,2.622,1.026l-0.513,0.762 c-0.424-0.513-1.201-0.894-2.109-0.894c-0.967,0-1.567,0.483-1.567,1.113c0,1.552,4.38,0.527,4.38,3.281 c0,1.187-0.952,2.138-2.783,2.138C196.306,481.758,195.325,481.406,194.607,480.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M201.477,472.764c0-0.41,0.337-0.747,0.732-0.747c0.41,0,0.747,0.337,0.747,0.747 c0,0.41-0.337,0.732-0.747,0.732C201.814,473.496,201.477,473.174,201.477,472.764z M201.667,481.582v-7.075h1.099v7.075H201.667 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M204.582,483.398l0.556-0.82c0.586,0.703,1.289,0.967,2.3,0.967c1.172,0,2.27-0.571,2.27-2.124 v-1.011c-0.513,0.718-1.377,1.26-2.373,1.26c-1.845,0-3.149-1.377-3.149-3.662c0-2.27,1.289-3.677,3.149-3.677 c0.952,0,1.802,0.469,2.373,1.245v-1.069h1.098v6.87c0,2.344-1.641,3.076-3.369,3.076 C206.237,484.453,205.417,484.219,204.582,483.398z M209.709,479.546v-3.091c-0.381-0.615-1.23-1.143-2.109-1.143 c-1.421,0-2.27,1.128-2.27,2.695c0,1.553,0.849,2.695,2.27,2.695C208.478,480.703,209.328,480.161,209.709,479.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M217.413,481.582v-4.629c0-1.245-0.63-1.641-1.582-1.641c-0.865,0-1.685,0.527-2.095,1.099v5.17 h-1.099v-7.075h1.099v1.025c0.498-0.586,1.464-1.201,2.519-1.201c1.48,0,2.256,0.747,2.256,2.285v4.966H217.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M219.932,478.037c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.894l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C221.441,481.758,219.932,480.249,219.932,478.037z M223.404,475.24c-1.509,0-2.256,1.274-2.314,2.358h4.643 C225.718,476.543,225.015,475.24,223.404,475.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M233.35,481.582v-1.055c-0.527,0.718-1.392,1.23-2.388,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.817,0.469,2.388,1.245v-3.765h1.098v9.77H233.35z M233.35,479.663v-3.208 c-0.396-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.849,2.724,2.27,2.724 C232.105,480.776,232.954,480.279,233.35,479.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M239.692,481.582v-9.77h1.098v3.765c0.572-0.776,1.421-1.245,2.388-1.245 c1.845,0,3.149,1.465,3.149,3.721c0,2.299-1.304,3.706-3.149,3.706c-0.996,0-1.86-0.513-2.388-1.23v1.055H239.692z  M242.9,480.776c1.436,0,2.285-1.157,2.285-2.724c0-1.568-0.85-2.739-2.285-2.739c-0.864,0-1.728,0.527-2.109,1.143v3.208 C241.171,480.279,242.036,480.776,242.9,480.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262C"
    },
    d: "M247.528,483.354c0.161,0.073,0.425,0.117,0.601,0.117c0.483,0,0.805-0.161,1.055-0.747 l0.469-1.069l-2.959-7.148h1.187l2.358,5.8l2.344-5.8h1.201l-3.545,8.51c-0.425,1.025-1.143,1.421-2.08,1.435 c-0.234,0-0.601-0.044-0.805-0.103L247.528,483.354z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackYourConstruction);
export default __webpack_public_path__ + "static/media/Track Your Construction.de077928639f5cebb927f76a4d0f0bd4.svg";
export { ForwardRef as ReactComponent };